import FF from "@/components/forms/FormField.module.css";

import { cn } from "@/utils/classNames.ts";
import {
    DateField,
    DateInput,
    DateSegment,
    FieldError,
    Label,
    type DateFieldProps,
    type DateValue,
} from "react-aria-components";

interface WDateFieldProps<T extends DateValue> extends DateFieldProps<T> {
    label?: string;
}

// TODO: Better integration with `FormField` so `label` / `aria-label` does not have to be duplicated
export function WDateField<T extends DateValue>({ label, ...props }: WDateFieldProps<T>) {
    return (
        <DateField
            className={cn(FF.DateField, props.isReadOnly && FF.isReadOnly)}
            // TODO: Pick a better hourCycle based on the locale
            hourCycle={24}
            {...props}
        >
            {!!label && <Label>{label}</Label>}
            <DateInput className={FF.DateInput} data-readonly>
                {(segment) => <DateSegment className={FF.DateSegment} segment={segment} />}
            </DateInput>
            <FieldError />
        </DateField>
    );
}
